import { render, staticRenderFns } from "./Info2.vue?vue&type=template&id=4a4d6018&scoped=true&"
import script from "./Info2.vue?vue&type=script&lang=js&"
export * from "./Info2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d6018",
  null
  
)

export default component.exports